export const WORKING_STATUS_INTERVAL_MS = 3800;

/** Generic in-progress copy. Do not describe the work — it is not tied to it. */
export const WORKING_STATUS_MESSAGES = [
  "Working on it…",
  "Still going…",
  "One moment…",
  "This may take a bit…",
  "Working in the background…",
  "Hang on…",
  "Still working…",
  "Give it a moment…",
] as const;

export function nextWorkingStatusIndex(exclude?: number): number {
  const n = WORKING_STATUS_MESSAGES.length;
  if (n <= 1) return 0;
  let next = Math.floor(Math.random() * n);
  if (next === exclude) next = (next + 1) % n;
  return next;
}
